import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useLocation, useNavigate } from "react-router";
import { UserRoles, UserRolesInfo } from "../shared/constants/enums";
import { AuthConstant } from "../shared/constants/all-constant";
import { logout } from "../store/loginSlice";
import { sessionRepository } from "../services/sessionRepository";
import { CommonFunctions } from "../shared/utils/CommonFunctions";

interface IProtectedRoute {
  role?: UserRoles;
  children: any;
}

function ProtectedRoute({ role, children }: IProtectedRoute) {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [baseUrl, setBaseUrl] = useState("/");
  const auth = useSelector((state: any) => state.login);
  const userRole =
    // auth.userInfo?.roleId === UserRoles.TUTOR
    //   ? UserRolesInfo[UserRoles.NURSING_STUDENT] :
    UserRolesInfo[auth.userInfo?.roleId as UserRoles];
  useEffect(() => {
    setBaseUrl(userRole?.route);
    const sameUser =
      auth.userInfo?.userName ===
      localStorage.getItem(AuthConstant.LOGIN_USER_NAME);

    if (!auth.authenticated) {
      location.state = { prev: location.pathname };
      dispatch(logout());
      navigate("/"); // Redirect to login if not authenticated
    }

    if (auth.authenticated && !sameUser) {
      sessionRepository
        .Logout()
        .then(() => {
          dispatch(logout());
          CommonFunctions.clearLocalStorage();
        })
        .finally(() => {
          navigate("/"); // Redirect to login if not authenticated
        });
    }

    if (auth.authenticated && role && auth.userInfo?.roleId !== role) {
      navigate(baseUrl, { replace: true });
    }
  }, [auth.authenticated, navigate, userRole]);

  if (auth.authenticated && !role) {
    return <Navigate to={baseUrl} />; // Redirect to defualt page if authenticated
  }
  if (auth.authenticated) {
    return children;
  }
  return null;
}

export default ProtectedRoute;
